module.exports = {
  Range: 'Range',
  SorryHavePermissionToInformation: 'Sorry! You do not have permission to view detailed information.',
  BusinessInformationSelectionIncorrect: 'Business information selection incorrect',
  DidOnThePreviousDay: 'Did not confirm on the previous day',
  DeclaredSameDayAsFlight: 'Declared on the same day as the flight',
  DeclaredOnTheSameDay: 'Declared on the same day',
  Other: 'Other',
  PleaseTheCustomsDeclarationList: 'Please choose the customs declaration list',
  LabelPrintingSucceeded: 'Label printing succeeded',
  ConfirmAudit: 'Confirm audit?',
  PleaseTheMasterBillInformation: 'Please choose the master bill information',
  TheNumberHasBeenInvalidated: 'The master bill number has been invalidated',
  CancellationSuccessful: 'Cancellation successful',
  CancellationFail: 'Cancellation fail',
  ConfirmBillNumberFromBusiness: 'Confirm unbinding this master bill number from the previous business?',
  UnbindingFailed: 'Unbinding failed',
  UnbindingSuccessful: 'Unbinding successful',
  MasterBill: 'Master bill',
  SubBill: 'Sub-bill',
  MasterBillStatus: 'Master bill status',
  SubBillStatus: 'Sub-bill status',
  EnterQueryInformation: 'Enter query information!',
  ConfirmThis: 'Confirm this',
  ReceiptNumber: 'Receipt number',
  AllFlightMustBeLocking: 'All orders under the current flight must be submitted before locking!',
  OtherDocuments: 'Other documents',
  CustomsDeclarationDocuments: 'Customs declaration documents',
  PleaseImageYouWantUpload: 'Please choose the image you want to upload',
  InvalidReceiptNumber: 'Invalid receipt number!',
  InvalidMasterBillNumber: 'Invalid master bill number',
  NoContactTheAirlineImages: 'No flight arrangement for this order number; please contact the airline to arrange a flight before uploading images',
  PleaseFileYouWantDownload: 'Please choose the file you want to download',
  UploadWantToUploadImage: 'Upload successful, do you want to upload next image?',
  BulkEditingDestinationPortInformation: 'Bulk editing destination port information',
  OverseasWarehouseNonAmazonWarehouse: 'Overseas transshipment warehouse, non-Amazon warehouse',
  EstimatedArrivalTime: 'Estimated arrival time',
  ActualArrivalTime: 'Actual arrival time',
  NoDataSelected: 'No data selected',
  AllAreInNonState: 'All selected data records are in non-"Normal operation" state',
  TheIsNotSelfConsolidation: 'The type of operation for this order is not self-consolidation, buyer consolidation or delegated consolidation',
  AttachmentTooLarge: 'Attachment too large',
  BusinessStatusChangeLog: 'Business status change log',
  DomesticWarehouse: 'Domestic warehouse',
  OverseasWarehouse: 'Overseas warehouse',
  LogRecords: 'Log records',
  GeneralTrade: 'General trade',
  OperationSuccessful: 'Operation successful',
  PleaseChooseAnAirline: 'Please choose an airline!',
  ContainerType: 'Container type',
  Size: 'Size',
  LockedPleaseContactSupervisorUnlocking: 'Locked, unable to print, please contact supervisor for unlocking!',
  ProfitAnalysisPrint: 'Profit analysis print',
  DoCopyMasterBillInformation: 'Do you want to copy master bill consignee/consignor information?',
  DeleteSucceeded: 'Delete succeeded!',
  PleaseFormatOfTheLengthwidthheightquantity: 'Please enter the correct format of the dimensions: length*width*height*quantity!',
  GenerationFailed: 'Generation failed!',
  CargoCollectionType: 'Cargo collection type',
  Commission: 'Commission',
  CustomsClearanceMethod: 'Customs clearance method',
  ServiceChannel: 'Service channel',
  ExpectedTimeIntoAmazonWarehouse: 'Expected entry time into Amazon warehouse',
  ZipCode: 'Zip code',
  DestinationDeliveryMethod: 'Destination delivery method',
  ExpressCompany: 'Express company',
  CourierNumber: 'Courier number',
  POOriginalOrderNumber: 'PO (Original order number)',
  EORIBusinessNumber: 'EORI Business number',
  VATTaxNumber: 'VAT/Tax number',
  VATRegistrationCountry: 'VAT Registration Country',
  VATRegistrationAddress: 'VAT Registration Address',
  VATCompanyEnglishName: 'VAT Company English Name',
  EstimatedDeliveryTime: 'Estimated Delivery Time',
  ActualDeliveryTime: 'Actual Delivery Time',
  WithBattery: 'With Battery',
  WithMagnet: 'With Magnet',
  Powder: 'Powder',
  Liquid: 'Liquid',
  EstimatedStorageGoodArrivalTime: 'Estimated Storage/Good Arrival Time',
  RemoteWarehouse: 'Remote Warehouse',
  AirFreight: 'Air Freight',
  FeeType: 'Fee Type:',
  EstimatedAmount: 'Estimated Amount:',
  Equivalent: 'Equivalent',
  FreightRateLevel: 'Freight Rate Level:',
  BilledWeight: 'Billed Weight:',
  CalculationMethod: 'Calculation Method:',
  EstimatedTimeCannotBeEmpty: 'Estimated storage/good arrival time cannot be empty!',
  DestinationCannotBeEmpty: 'Destination cannot be empty!',
  DestinationCountryCannotBeEmpty: 'Destination country cannot be empty!',
  ZipCodeCannotBeEmpty: 'Zip code cannot be empty!',
  CannotBeEmpty: ' Cannot be empty!',
  InvalidBillNumberCannotBind: 'Invalid master bill number, cannot bind!',
  PleaseTheConsignorUnitFirst: 'Please select the consignor unit first.',
  TheExpensesCanNotMode: 'The current ticket has shared expenses, can not switch the operation mode!',
  DoRefreshTheMAWBInformation: 'Do you want to refresh the MAWB related information?',
  CourierCompany: 'Courier Company',
  ForeignWarehouse: 'Foreign Warehouse',
  CustomsDeclarationMethod: 'Customs Declaration Method',
  TheSharedExpensesCanSeparate: 'The current ticket has shared expenses, can not separate!',
  RemoveTicketSuccessfully: 'Remove ticket successfully!',
  AttachmentDescription: 'Attachment Description:',
  AirlineCannotBeEmpty: 'Airline cannot be empty',
  AddNew: 'Add New',
  NoItemDetailsSelected: 'No item details selected!',
  SellingPriceCalculationCompleted: 'Selling price calculation completed',
  PleaseSelectWarehouseEntryData: 'Please select warehouse entry data!',
  DeletedSuccessfully: 'Deleted successfully!',
  PleaseAPieceOfData: 'Please select a piece of data!',
  CustomsClearanceTracking: 'Customs Clearance Tracking',
  CustomsClearanceQuantity: 'Customs Clearance Quantity',
  CustomsClearanceWeight: 'Customs Clearance Weight',
  CustomsClearanceDate: 'Customs Clearance Date',
  CustomsClearanceInformation: 'Customs Clearance Information',
  MultipleCustomsDeclarations: 'Multiple Customs Declarations',
  WhetherApplyForCommercialInspection: 'Whether to apply for commercial inspection',
  WhetherToCheck: 'Whether to check',
  PleaseSelectCustomsClearanceInformation: 'Please select customs clearance information.',
  TheBeEqualToBusiness: 'The total weight of the customs clearances must be equal to the actual weight of the business.',
  NextLegEntry: 'Next Leg Entry',
  ActualFlight: 'Actual Flight:',
  NextLegInformation: 'Next Leg Information:',
  ActualFlightCannotBeEmpty: 'Actual flight cannot be empty.',
  ActualDepartureDate: 'Actual departure date.',
  NextInformationCannotBeEmpty: 'Next leg information cannot be empty.',
  BatchModificationOfReportStatus: 'Batch modification of report status',
  CustomsClearanceStatus: 'Customs Clearance Status:',
  PleaseSelectCustomsClearanceStatus: 'Please select customs clearance status.',
  SelectAirPort: 'Select Air Port',
  PleaseSelectAPort: 'Please select a port!',
  FlightSelection: 'Flight Selection',
  Monday: 'Monday',
  Tuesday: 'Tuesday',
  Wednesday: 'Wednesday',
  Thursday: 'Thursday',
  Friday: 'Friday',
  Saturday: 'Saturday',
  Sunday: 'Sunday',
  FlightSchedule: 'Flight Schedule',
  Weekly: 'Weekly',
  PleaseSelectAFlight: 'Please select a flight.',
  PleaseEnterACode: 'Please enter a code!',
  CodeExistsPleaseReEnter: 'Code already exists, please re-enter!',
  PleaseEnterAName: 'Please enter a name!',
  PleaseAddARegionalPort: 'Please add a regional port!',
  AreYouWantToDelete: 'Are you sure you want to delete?',
  PleaseTheDepartureRegionCode: 'Please enter the departure region code!',
  PleaseTheDestinationRegionCode: 'Please enter the destination region code!',
  DepartureRegionCodeCannotSame: 'Departure region code and destination region code cannot be the same!',
  WeeklySchedule: 'Weekly Schedule',
  PleaseEffectiveDateStartTime: 'Please select the effective date start time!',
  PleaseSelectTheSchedule: 'Please select the schedule!',
  PleaseEnterTheTransshipmentPort: 'Please enter the transshipment port.',
  AreWantToDeleteRoute: 'Are you sure you want to delete the route?',
  GenerateFlight: 'Generate Flight',
  PleaseEnterAFlightNumber: 'Please enter a flight number!',
  PleaseEnterAnAirline: 'Please enter an airline!',
  PleaseEnterTheDeparturePort: 'Please enter the departure port!',
  PleaseEnterTheDestinationPort: 'Please enter the destination port!',
  PleaseDepartureTimeForWeek: 'Please enter the departure time for ',
  AreWantToDeleteFlight: 'Are you sure you want to delete the flight?',
  TheWantToDeleteRegenerate: 'The flight has been generated, do you want to delete the original information and regenerate?',
  GenerationSuccessful: 'Generation successful.',
  AtBookingNatureAirportEntered: 'At least one of the routes, airlines, booking nature, airport, and sales must be entered!',
  ResponsibilitiesAssignedNoDeletionAllowed: 'Responsibilities have been assigned, no deletion allowed!',
  AreToDeleteThisRecord: 'Are you sure to delete this record?',
  TheTheAirlineIsModify: 'The three-letter maintenance of the airline is incorrect, please modify!',
  PleaseSelectAnAirline: 'Please select an airline!',
  PleaseSelectTheExpirationDate: 'Please select the expiration date!',
  PleaseStartingMasterBillNumber: 'Please enter the starting master bill number!',
  TheLegalThereIsAirline: 'The starting number is not legal, there is no matching airline!',
  TheNumberIsNotLegal: 'The master bill number is not legal!',
  PleaseTheDateOfPossession: 'Please select the date of possession!',
  TheMasterBillMayExist: 'The current number segment master bill may already exist!',
  ConfirmDeleteTheMasterBill: 'Confirm to delete the master bill?',
  CancelSubmission: 'Cancel submission',
  SaveSuccessfully: 'Save successfully!',
  SaveSuccess: 'Save success',
  PleaseTheWarehouseEntryNumber: 'Please enter the warehouse entry number!',
  PleaseWeightOfTheSeal: 'Please select the weight of the seal!',
  PleaseEnterTheWarehouseName: 'Please enter the warehouse name!',
  ReviewSucceeded: 'Review succeeded!',
  LockedContactAHigherUnlock: 'Locked, unable to print, please contact a higher-level supervisor to unlock!',
  PleasePortOfDepartureDestination: 'Please enter a port of departure or destination!',
  SaveFileFormatIsIncorrect: 'Save failed, Excel file format is incorrect!',
  SuccessfullyImported: 'Successfully imported',
  PiecesOfData: 'pieces of data!',
  SaveFailed: 'Save failed!',
  PleaseThePortOfDeparture: 'Please enter the port of departure!',
  CompleteOperationRequirements: 'Complete operation requirements',
  PleaseSelectTheCompletionTime: 'Please select the completion time.',
  CurrentlySelected: '(Currently selected)',
  CurrentPage: ' (Current page)',
  CompletionStatus: ' Completion status',
  Completed: 'Completed',
  Uncompleted: 'Uncompleted',
  OperationRequirementDescription: 'Operation requirement description',
  CurrentSelectionIncludesCompletedStatus: 'Current selection includes completed status.',
  OperationRequirementTracking: 'Operation requirement tracking',
  ConfirmCancellation0: 'Confirm cancellation [{0}]?',
  DeDepartureTime: '\' departure time.',
  AERequiredChecksum: 'One of the main single start number and batch addition must be filled in',
  FlightInformation: 'Flight information',
  TrackingDetails: 'Tracking details',
  StartingStation: 'Starting station',
  DestinationStation: 'Destination Station',
  FlightNumber: 'Flight number',
  DepartureTime: 'Departure time',
  ArrivalTime: 'arrival time',
  Pieces: 'Number of pieces',
  Weight: 'Weight',
  Time: 'Time',
  Status: 'State',
  Airport: 'Airport',
  Unknown: 'Unknown',
  BKD: 'Booking',
  RCS: 'Entering the warehouse',
  MAN: 'Allocate vehicles to transport sth.',
  DEP: 'Take off',
  ARR: 'Arrival',
  AWD: 'Acquiring',
  RCF: 'Unloading',
  NFD: 'Delivery Notice',
  DLV: 'Picking up goods',
  TAR: 'Transit Port Arrival',
  TDE: 'Transit Port Departure',
  TRF: 'Cargo Unload At Transit Port',
  RWB: 'Document Received',
  CUS: 'Customs Clearance',
  AeMawbChargeWeight: 'Air freight bill making and billing weight',
  AeBookingChargeWeight: 'Air freight booking billing weight',
  MawbChargeWeight: 'Bill of lading weight',
  BookingChargeWeight: 'Booking and billing weight',
  ImportBoardInstallInfo: 'Import board installation information',
  PleaseImportCorrectTemplate: 'Please import the information of the correct template',
  ClickDownloadTemplate: 'Click to download template',
  AsyncUploadLogView: 'As an asynchronous operation, you can view the import result in "File Storage ->Upload Log"',
  ServiceInformation: 'Service Information',
  ControlDisplayConfiguration: 'Control Display Configuration',
  WovenFabricorder: 'Woven fabric (order)',
  BookingForCargobooking: 'Booking for cargo (booking)',
  ItemMaoTiForwardWarehouseActual: 'ItemMaoTi (Forward Warehouse (Actual))',
  ItemMaoTiOrderProcessing: 'ItemMaoTi (Order Processing)'
}
